// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../.yarn/__virtual__/css-loader-virtual-2ae40ad6f9/0/cache/css-loader-npm-3.5.3-0f886851e6-e5fa1707d7.zip/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".measured-modal-wrapper>div{position:static !important}.measured-modal-wrapper>div>div:nth-child(2){max-height:600px}.measured-modal-wrapper>div>div:nth-child(3){position:absolute;left:10px;bottom:0;width:100%;margin-left:-12px;z-index:1}\n", ""]);
// Exports
module.exports = exports;
